module.exports = __webpack_public_path__ + "static/img/21.b36e52c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/2/21.png
// module id = I5XX
// module chunks = 0